class BellezaProduct {
  constructor(root) {
    this.root = root;
    this.thumbs = Array.from(root.querySelectorAll('[data-belleza-thumb]'));
    this.panels = Array.from(root.querySelectorAll('[data-belleza-panel]'));
    this.optionControls = Array.from(root.querySelectorAll('[data-belleza-option]'));
    this.variantMap = root.querySelector('[data-belleza-variant-map]');
    this.variantInput = root.querySelector('[data-belleza-variant-id]');
    this.price = root.querySelector('[data-belleza-price]');
    this.addButton = root.querySelector('[data-belleza-add]');
    this.addText = root.querySelector('[data-belleza-add-text]');
    this.bindGallery();
    this.bindVariants();
  }

  bindGallery() {
    this.thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => this.selectMedia(thumb.dataset.mediaId));
    });
  }

  selectMedia(mediaId) {
    this.thumbs.forEach((thumb) => {
      const active = thumb.dataset.mediaId === mediaId;
      thumb.classList.toggle('is-active', active);
      thumb.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    this.panels.forEach((panel) => {
      const active = panel.dataset.mediaId === mediaId;
      if (active) {
        panel.hidden = false;
        requestAnimationFrame(() => panel.classList.add('is-active'));
      } else {
        panel.classList.remove('is-active');
        window.setTimeout(() => {
          if (!panel.classList.contains('is-active')) panel.hidden = true;
        }, 240);
      }
    });
  }

  bindVariants() {
    if (!this.variantMap || this.optionControls.length === 0) return;
    this.optionControls.forEach((control) => {
      control.addEventListener('change', () => this.syncVariant());
    });
  }

  syncVariant() {
    const selected = this.optionControls.map((control) => control.value).join('||');
    const variantOption = Array.from(this.variantMap.options).find((option) => option.dataset.options === selected);
    if (!variantOption) return;

    const available = variantOption.dataset.available === 'true';
    const price = variantOption.dataset.price || '';

    this.variantMap.value = variantOption.value;
    if (this.variantInput) this.variantInput.value = variantOption.value;
    if (this.price) this.price.textContent = price;
    if (this.addButton) this.addButton.disabled = !available;
    if (this.addText) this.addText.textContent = available ? `Add to bag - ${price}` : 'Sold out';
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-belleza-product]').forEach((root) => new BellezaProduct(root));
});
